"use client";

import { ProductFull } from "@api";
import { AdvancedProductCard } from "./AdvancedProductCard";
import { useTranslations } from "@/app/(site)/europe/useTranslations";

export const Desktop = ({ products }: { products: ProductFull<string>[] }) => {
  const {
    activeAxilMiniAirDescription,
    activeAxilMiniProDescription,
    activeAxilDescription,
    activeLeafDescription,
    activeCeramicDescription,
    ezclickCeramicProDescription,
    ezclickGlassDescription,
    activeRootXlDescription,
    activeSproutDescription,
    availableMouthpieces,
  } = useTranslations();

  const getNeededDescription = (slug: string) => {
    switch (slug) {
      case "active-axil-mini-air":
        return activeAxilMiniAirDescription;
      case "active-axil-mini-pro":
        return activeAxilMiniProDescription;
      case "active-axil":
        return activeAxilDescription;
      case "active-leaf":
        return activeLeafDescription;
      case "active-ceramic":
        return activeCeramicDescription;
      case "ezclick-ceramic-pro":
        return ezclickCeramicProDescription;
      case "ezclick-glass":
        return ezclickGlassDescription;
      case "active-root-xl":
        return activeRootXlDescription;
      case "active-sprout":
        return activeSproutDescription;
      default:
        return "";
    }
  };

  // Wrapped flex rather than a grid: every block here ends in a short row — four all-in-ones,
  // two cartridges, two batteries — and a short grid row is stuck against the left edge. The
  // cells keep the three-up width (two 1.5rem gaps taken off the line) so full rows are
  // identical to the grid's, while the trailing tiles sit centered under them.
  return (
    <div className="flex flex-wrap justify-center gap-6">
      {products.map((p) => (
        <div
          key={`eu-product-${p.slug}`}
          className="w-full md:w-[calc((100%-3rem)/3)]"
        >
          <AdvancedProductCard
            p={p}
            pDescription={getNeededDescription(p.slug)}
            mouthpiecesLabel={availableMouthpieces}
          />
        </div>
      ))}
    </div>
  );
};
